module.exports = __webpack_public_path__ + "aa.no1.094da4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aa.no1.jpg
// module id = 141R
// module chunks = 0